import React, { Component } from "react";
import PropTypes from "prop-types";
import { Group, Image, Circle, Text, Rect } from 'react-konva';
import useImage from 'use-image';


const PicturePreview =
    React.memo(function PicturePreview({ imageNew }) {
        const [image] = useImage(imageNew);
        return (<Image
            image={image} x={0} y={0} />);

    });

export default class ImagePreview extends Component {


    shouldComponentUpdate(nextProps) {
        if (nextProps.imageNew !== this.props.imageNew || 
            nextProps.selectedROI !== this.props.selectedROI  
           ) 
        {
            return true;
        } else {
            return false;
        }
    }

    roiColor = (color) => {
        switch (color) {
            case 1: {
                return "white";
            }
            case 2: {
                return "black";
            }
            case 3: {
                return "blue";
            }
            case 4: {
                return "yellow";
            }
            case 5: {
                return "green";
            }
        }
    }

    setRedColor = (label, i) => {

        const { selectedROI, indexSelectedROI } = this.props;

        if (selectedROI == label || (indexSelectedROI - i == 1 && indexSelectedROI % 2 !== 0)) {
            return true;
        } else
            return false;
    }

    render() {
        const { imageNew, isActiveTempImage, rois, zoomValue, roiTextValueX, roiTextValueY, notes, selectedROI } = this.props;

        return (
            <Group >
                <PicturePreview imageNew={imageNew} />
                {
                    isActiveTempImage && rois.map((roi, i) =>
                        <Circle key={i}
                            x={roi.x * zoomValue}
                            y={roi.y * zoomValue}
                            radius={roi.radius * zoomValue}
                            name={roi.label}
                            stroke={this.setRedColor(roi.label, i) ? "red" : this.roiColor(roi.o_color)}
                            fillEnabled="false"
                        />
                    )
                }
                {
                    isActiveTempImage && rois.map((roi, i) =>
                        <Text key={i}
                            x={roiTextValueX(roi, zoomValue)}
                            y={roiTextValueY(roi, zoomValue)}
                            text={roi.label}
                            fontFamily="Calibri"
                            fontSize={(selectedROI == roi.label) ? 20 * zoomValue : 12 * zoomValue}
                            fill={this.roiColor(roi.o_color)} 
                        />
                    )
                }
                {
                    isActiveTempImage && notes.map((note, i) =>
                        <Rect key={i}
                            fontFamily="Calibri"
                            fontSize={note.notefontsize * zoomValue}
                            text={note.note}
                            x={Number(note.x * zoomValue)}
                            y={Number(note.y * zoomValue)}
                            width={Number(note.width * (zoomValue))}
                            height={Number(note.height * (zoomValue))}
                            fill={"white"}
                        />
                    )
                }
                {
                    isActiveTempImage && notes.map((note, i) =>
                        <Text key={i}
                            fontFamily="Arial"
                            fontSize={note.notefontsize * (zoomValue - 0.09)}
                            fontStyle={"normal"}
                            text={note.note}
                            x={Number(note.x * zoomValue + 4)}
                            y={Number(note.y * zoomValue + 4)}
                            width={Number(note.width * (zoomValue))}
                            height={Number(note.height * (zoomValue ))}
                            verticalAlign={"middle"}
                        />
                    )
                }
            </Group >
        );
    }
};

ImagePreview.propTypes = {

};
